<template>
  <div class='info-home-component'>
    <div id="info-container">
       <div class='info-title fade'>QUI SOMMES-NOUS ?</div>
      <div class='info-underline fade'></div>
      <div class='info-details-container fade'>
        <div ref="iconContainer" class='info-details-icon-container'>
          <div class="info-details-icon"/>
        </div>
        <div class='info-text-one'>
          <b>L'Atelier</b> est un <b>studio de développement de produits</b> dédié à <b>l'innovation</b>. Nous créons des services <br/><b>sur-mesure</b> ambitieux pour nos clients et portons une attention constante à la <b>qualité du code</b>.
        </div>
        <div class='info-separate-text-line'></div>
        <div class='info-text-two'>
          <b>Shokunin</b> est l'entité <b>formation</b> de <b>L'Atelier</b>. C'est aussi un état d'esprit japonais qui nous invite à <b>s'entrainer rigoureusement</b> dans un domaine afin d'atteindre l'<b>état de son art</b>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'InfoHomeComponent',

  props: ['controller'],

  data () {
    return {
      scenes: [],
      iconShowed: false
    }
  },

  mounted () {
    if (this.isMobile()) return

    this.initScenes()
  },

  methods: {
    isShowed (el) {
      const rect = el.getBoundingClientRect()
      if (rect.top < 0 || rect.top > window.innerHeight) {
        return false
      }
      if (rect.left < 0 || rect.left > window.innerWidth) {
        return false
      }
      return true
    },
    isMobile () {
      return window.innerWidth < 480
    },

    initFadeIn () {
      const fades = this.$el.querySelectorAll('.fade')
      gsap.set(fades, { alpha: 0, y: 400 })
      gsap.set('.info-underline', { width: 0 })

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.info-home-component',
          start: 'top+=-150 bottom'
        }
      })
      tl
        .to(fades, { duration: 0.8, alpha: 1, y: '-=500', stagger: 0.2 }, 'b')
        .to('.info-underline', { duration: 1, width: '9%' }, 'b-=0.5')
    },

    initParalax () {
      gsap.to('#info-container', {
        y: '-=200',
        ease: 'none',
        scrollTrigger: {
          trigger: '.info-home-component',
          start: 'top bottom',
          end: '+=' + (typeof window !== 'undefined' ? window.innerHeight : 1000),
          scrub: true
        }
      })
    },

    initScenes () {
      this.initFadeIn()
      this.initParalax()
    }

  }

}
</script>

<style lang='scss' scoped>

#info-container {
  padding: 0 64px;
  max-width: 1400px;
  margin: 0 32px;
  @include media(phone) {
  margin: 0 32px;
    padding: 154px 32px 84px 32px;
  }
}

.info-home-component {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;

  height: 80vh;
  min-height: calc((1080px / 100) * 80);

  @include media(phone) {
    height: unset;
  }

  .info-title {
    @extend %default-title;
  }

  .info-underline {
    @extend %default-underline;
  }

  .info-details-container {
    box-shadow: 0 2px 6px 0 rgba(176, 175, 175, 0.5);
    max-width: 1400px;

    align-items: center;
    background-color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
    align-items: center;
    padding: 32px 64px 64px 64px;

    @include media(phone) {
      padding: 0 16px;
      padding-bottom: 32px;
    }

    .info-details-icon-container {
      display: flex;

      flex-direction: row;
      justify-content: center;
      margin: 32px 0;

      height: 68px;
      width: 68px;

      .info-details-icon {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left center;
        background-image: url('../../assets/hands.png');

        height: 100%;
        width: 100%;

        animation: play var(--animation-duration) steps(var(--icon-step)) infinite;
      }
    }

    .info-text {
      color: #494949;
      font-size: 1.1rem;
      font-weight: 100;
      letter-spacing: -0.05px;
      line-height: 24px;
      text-align: center;

      b {
        font-weight: 500;
      }
    }

    .info-text-one {
      @extend .info-text;

      grid-column: 2;
      grid-row: 2;
    }

    .info-text-two {
      @extend .info-text;

      grid-column: 2;
      grid-row: 4;
    }

    .info-separate-text-line {
      border-bottom: 1px dotted #B98A30;
      grid-column: 2;
      grid-row: 3;
      margin: 25px auto;
      width: 10%;
    }
  }
}
</style>
